import PropTypes from 'prop-types';
import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import ClassicCopyCompanyPropertyActionMetadata from 'automation-ui-action-features/actions/classic-copy-company-property/records/ClassicCopyCompanyPropertyActionMetadata';
import ClassicCopyCompanyPropertyActionDetail from 'automation-ui-action-features/actions/classic-copy-company-property/ClassicCopyCompanyPropertyActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class ClassicCopyCompanyPropertyActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(ClassicCopyCompanyPropertyActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
ClassicCopyCompanyPropertyActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicCopyCompanyPropertyActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default ClassicCopyCompanyPropertyActionHistoryCard;